const EntryCategory = {
  RECEIPT: 1,
  PAYMENT: 2,
  BANK: 3,
  PURCHASE: 4,
  SALE: 5,
  OTHER: 0,
};

const ReceiptCategory = {
  CUSTOMER_ADVANCE_PAYMENT: 11,
  CUSTOMER_REPAYMENT: 12,
  BANK_WITHDRAWAL: 13,
  BORROWING_LOAN: 14,
  CAPITAL_CONTRIBUTION: 15,
  EMPLOYEE_REIMBURSEMENT: 16,
  OTHER_RECEIPT: 10,
};

const PaymentCategory = {
  EMPLOYEE_ADVANCE_PAYMENT: 21,
  EMPLOYEE_SALARY: 22,
  SUPPLIER_ADVANCE_PAYMENT: 23,
  SUPPLIER_REPAYMENT: 24,
  BANK_DEPOSIT: 25,
  LENDING: 26,
  OTHER_PAYMENT: 20,
};

const PaymentStatus = {
  DEPT: 1,
  PAID: 2,
  AUTO: 3,
  NONE: 4,
};

const PaymentStatusStr = {
  [PaymentStatus.DEPT]: 'Nợ',
  [PaymentStatus.PAID]: 'Đã trả',
  [PaymentStatus.AUTO]: 'Tự động',
};

const PaymentMethod = {
  CASH: 1,
  BANK: 2,
};

const AmountPercentPinned = {
  NOTHING: 0,
  AMOUNT: 1,
  PERCENT: 2,
};

const PricePinned = {
  NOTHING: 0,
  UNIT_PRICE: 1,
  TOTAL_PRICE: 2,
};

const ItemCategory = {
  MERCHANDISE: 11,
  MATERIAL: 21,
  TOOL: 22,

  IMMEDIATE_EXPENSE: 31,
  APPORTION_EXPENSE: 32,
  FIXED_ASSET_EXPENSE: 33,
  PURCHASE_EXPENSE: 34,
  OUTSOURCE_SERVICE: 35,

  FINISHED_GOOD: 41,
  PRODUCTION_ORDER: 42,
  SUPPLIED_SERVICE: 43,
  TRADED_SERVICE: 44,

  OTHER_EXPENSE: 51,
  OTHER_REVENUE: 52,
};

const ItemCategoryGroup = {
  inventory: [ItemCategory.MERCHANDISE, ItemCategory.MATERIAL, ItemCategory.TOOL, ItemCategory.FINISHED_GOOD],
  purchase_inventory: [ItemCategory.MERCHANDISE, ItemCategory.MATERIAL, ItemCategory.TOOL],
  purchase: [
    ItemCategory.MERCHANDISE, ItemCategory.MATERIAL, ItemCategory.TOOL,
    ItemCategory.OUTSOURCE_SERVICE, ItemCategory.IMMEDIATE_EXPENSE, ItemCategory.APPORTION_EXPENSE,
    ItemCategory.FIXED_ASSET_EXPENSE, ItemCategory.PURCHASE_EXPENSE, ItemCategory.OTHER_EXPENSE,
  ],
  sale: [
    ItemCategory.MERCHANDISE, ItemCategory.MATERIAL, ItemCategory.TOOL,
    ItemCategory.FINISHED_GOOD, ItemCategory.PRODUCTION_ORDER, ItemCategory.SUPPLIED_SERVICE, ItemCategory.TRADED_SERVICE, ItemCategory.OTHER_REVENUE,
    ItemCategory.APPORTION_EXPENSE, ItemCategory.FIXED_ASSET_EXPENSE,
  ],
  apportion: [
    ItemCategory.OUTSOURCE_SERVICE, ItemCategory.IMMEDIATE_EXPENSE,
    ItemCategory.APPORTION_EXPENSE, ItemCategory.FIXED_ASSET_EXPENSE,
  ],
};

const ItemCategoryStr = {
  [ItemCategory.MERCHANDISE]: 'Hàng hoá',
  [ItemCategory.MATERIAL]: 'Nguyên vật liệu',
  [ItemCategory.TOOL]: 'Công cụ dụng cụ',

  [ItemCategory.IMMEDIATE_EXPENSE]: 'Chi phí dùng ngay',
  [ItemCategory.APPORTION_EXPENSE]: 'Chi phí trả trước',
  [ItemCategory.FIXED_ASSET_EXPENSE]: 'Tài sản cố định',
  [ItemCategory.PURCHASE_EXPENSE]: 'Chi phí mua hàng',
  [ItemCategory.OUTSOURCE_SERVICE]: 'Chi phí thuê ngoài',

  [ItemCategory.FINISHED_GOOD]: 'Thành phẩm',
  [ItemCategory.PRODUCTION_ORDER]: 'Sản phẩm theo đơn hàng',
  [ItemCategory.SUPPLIED_SERVICE]: 'Dịch vụ, đơn hàng',
  [ItemCategory.TRADED_SERVICE]: 'Dịch vụ thương mại',

  [ItemCategory.OTHER_EXPENSE]: 'Chi phí khác',
  [ItemCategory.OTHER_REVENUE]: 'Bán ra khác',
};

const Department = {
  SALE: 1,
  MANAGEMENT: 2,
  PRODUCTION: 3,
};

const DepartmentStr = {
  [Department.SALE]: 'Bán hàng',
  [Department.MANAGEMENT]: 'Quản lý',
  [Department.PRODUCTION]: 'Sản xuất',
};

const VatMethod = {
  DEDUCT: 'deduct',
  DIRECT: 'direct',
  DIRECT_VA: 'direct_va',
};

const VatMethodStr = {
  [VatMethod.DEDUCT]: 'Khấu trừ',
  [VatMethod.DIRECT]: 'Trực tiếp',
  [VatMethod.DIRECT_VA]: 'TT GTGT, Vàng bạc',
};

const VatCategory = {
  HAS_VAT: 'has_vat',
  NO_VAT: 'no_vat',
  BOTH: 'both',
};

const VatCategoryStr = {
  [VatCategory.HAS_VAT]: 'Chịu thuế',
  [VatCategory.NO_VAT]: 'Không chịu thuế',
  [VatCategory.BOTH]: 'Cả hai',
};

const ConsumeCategory = {
  HAS_VAT: 1,
  NO_VAT: 2,
  BOTH: 3,
};

const ConsumeCategoryStr = {
  [ConsumeCategory.HAS_VAT]: 'Chịu thuế',
  [ConsumeCategory.NO_VAT]: 'Không chịu thuế',
  [ConsumeCategory.BOTH]: 'Cả hai',
};

const ExpenseRecordCategory = {
  DECLARE: 1,
  PURCHASE: 2,
};

const AccountRecordCategory = {
  GENERAL: 1,
  PURCHASE: 2,
  SALE: 3,
  EXPENSE_APPORTION: 4,
  BANK: 5,
  SALARY: 6,
  INVENTORY: 7,
};


const AccountRecordSubCategory = {
  PURCHASE_GOOD: 21,
  PURCHASE_VAT: 22,
  PURCHASE_IMPORT_TAX: 23,
  PURCHASE_EXPENSE: 24,

  SALE_REVENUE: 31,
  SALE_VAT: 32,
  SALE_COST: 33,

  INVENTORY_EXPORT: 71,
};


const FileStatus = {
  ENABLED: 1,
  DISABLED: 2,
  DELETED: -1,
};

const FileType = {
  DIRECTORY: 'directory',
  FILE: 'file',
  IMAGE: 'image',
  PDF: 'pdf',
  ANY_FILE: 'any_file',
};

const FileTypeInfo = {
  [FileType.DIRECTORY]: 'Thư mục',
  [FileType.FILE]: 'File',
  [FileType.IMAGE]: 'File ảnh',
  [FileType.PDF]: 'File pdf',
};

const FileCategory = {
  SALE: 'sale',
  PURCHASE: 'purchase',
  BANK: 'bank',
  GENERAL: 'general',
  EMPLOYEE: 'employee',
  OTHER: 'other',
};

const FileCategoryInfo = {
  [FileCategory.PURCHASE]: 'Mua hàng',
  [FileCategory.SALE]: 'Bán hàng',
  [FileCategory.BANK]: 'Ngân hàng',
  [FileCategory.GENERAL]: 'Tổng hợp',
  [FileCategory.EMPLOYEE]: 'Nhân viên',
  [FileCategory.OTHER]: 'Khác',
};

const InputRequiredFileCategory = [FileCategory.PURCHASE, FileCategory.SALE, FileCategory.BANK, FileCategory.GENERAL, FileCategory.EMPLOYEE];

const FileState = {
  PENDING: 'pending',
  CLASSIFIFED: 'classified',
  PROCESSED: 'processed',
};

const FileStateInfo = {
  [FileState.PENDING]: 'Chưa phân loại',
  [FileState.CLASSIFIFED]: 'Đã phân loại',
  [FileState.PROCESSED]: 'Đã hạch toán',
};

const WeightType = {
  QQ: 3,
  QV: 2,
  VQ: 1,
  VV: 0,
};

const MaterialExportMethod = {
  MONTHLY_MATERIAL: 2,
  MONTHLY_PRODUCT: 1,
  MONTHLY_SALE: 0,
};

const MaterialExportMethodStr = {
  [MaterialExportMethod.MONTHLY_MATERIAL]: 'Xuất tổng cộng trong tháng',
  [MaterialExportMethod.MONTHLY_PRODUCT]: 'Xuất theo sản phẩm trong tháng',
  [MaterialExportMethod.MONTHLY_SALE]: 'Xuất theo từng đơn hàng',
};

const InventoryRecordType = {
  INITIAL: 1,
  PURCHASE: 2,
  EXPORT_FOR_PRODUCTION: 3,
  IMPORT_AFTER_PRODUCTION: 4,
  SALE: 5,
  SUMMARY: 6,
  EXPORT_FOR_PRODUCTION_MANUALLY: 31,
};

const CommentState = {
  NONE: 0,
  OPENED: 1,
  RESOLVED: 2,
  REOPENED: 3,
  UNRESOVLED: 4,
};

const NotificationStatus = {
  DISABLED: -1,
  UNREAD: 0,
  READ: 1,
};

const FGPMethod = {
  INDIVIDUAL: 0, //  # Produce finished good for individual sales
  BATCH: 1, // Produce finished batch in period of time (monthly,...)
};

const FGPMethodStr = {
  [FGPMethod.INDIVIDUAL]: 'Cho từng đơn hàng',
  [FGPMethod.BATCH]: 'Hàng loạt theo tháng',
};

const ExpenseInputType = {
  PURCHASE_RECORD: 1,
  PURCHASE_ENTRY: 2,
  ITEM: 3,
  ITEM_GROUP: 4,
  EMPLOYEE: 5,
  EMPLOYEE_GROUP: 6,

  PURCHASE_EXPENSE_RECORD: 11,
  PURCHASE_EXPENSE_ENTRY: 12,
  PURCHASE_EXPENSE_ITEM: 13,
  PURCHASE_EXPENSE_ITEM_GROUP: 14,
};

const ExpenseInputTypeStr = {
  [ExpenseInputType.PURCHASE_RECORD]: 'Mã mua vào',
  [ExpenseInputType.PURCHASE_ENTRY]: 'Mã hóa đơn mua vào',
  [ExpenseInputType.ITEM]: 'Mặt hàng mua vào',
  [ExpenseInputType.ITEM_GROUP]: 'Nhóm mặt hàng',
  [ExpenseInputType.EMPLOYEE]: 'Nhân viên',
  [ExpenseInputType.EMPLOYEE_GROUP]: 'Nhóm nhân viên',

  [ExpenseInputType.PURCHASE_EXPENSE_RECORD]: 'Mã dòng chi phí mua hàng',
  [ExpenseInputType.PURCHASE_EXPENSE_ENTRY]: 'Mã hóa đơn chi phí mua hàng',
  [ExpenseInputType.PURCHASE_EXPENSE_ITEM]: 'Mặt hàng chi phí',
  [ExpenseInputType.PURCHASE_EXPENSE_ITEM_GROUP]: 'Nhóm mặt hàng chi phí',
};

const ExpenseOutputType = {
  SALE_RECORD: 1,
  SALE_ENTRY: 2,
  ITEM: 3,
  ITEM_GROUP: 4,

  PURCHASE_RECORD: 11,
  PURCHASE_ENTRY: 12,
  PURCHASE_ITEM: 13,
  PURCHASE_ITEM_GROUP: 14,
};

const ExpenseOutputTypeStr = {
  [ExpenseOutputType.SALE_RECORD]: 'Mã bán ra',
  [ExpenseOutputType.SALE_ENTRY]: 'Mã hóa đơn bán ra',
  [ExpenseOutputType.ITEM]: 'Mặt hàng bán ra',
  [ExpenseOutputType.ITEM_GROUP]: 'Nhóm mặt hàng',

  [ExpenseOutputType.PURCHASE_RECORD]: 'Mã mua vào',
  [ExpenseOutputType.PURCHASE_ENTRY]: 'Mã hóa đơn mua vào',
  [ExpenseOutputType.PURCHASE_ITEM]: 'Mặt hàng mua vào',
  [ExpenseOutputType.PURCHASE_ITEM_GROUP]: 'Nhóm mặt hàng',
};

const ExpenseInputTypeGroups = {
  sale: [
    ExpenseInputType.PURCHASE_RECORD, ExpenseInputType.PURCHASE_ENTRY,
    ExpenseInputType.ITEM, ExpenseInputType.ITEM_GROUP,
    ExpenseInputType.EMPLOYEE, ExpenseInputType.EMPLOYEE_GROUP,
  ],
  purchase: [
    ExpenseInputType.PURCHASE_EXPENSE_RECORD, ExpenseInputType.PURCHASE_EXPENSE_ENTRY,
    ExpenseInputType.PURCHASE_EXPENSE_ITEM, ExpenseInputType.PURCHASE_EXPENSE_ITEM_GROUP,
  ],
};


const ExpenseOutputTypeGroups = {
  sale: [
    ExpenseOutputType.SALE_RECORD, ExpenseOutputType.SALE_ENTRY,
    ExpenseOutputType.ITEM, ExpenseOutputType.ITEM_GROUP,
  ],
  purchase: [
    ExpenseOutputType.PURCHASE_RECORD, ExpenseOutputType.PURCHASE_ENTRY,
    ExpenseOutputType.PURCHASE_ITEM, ExpenseOutputType.PURCHASE_ITEM_GROUP,
  ],
};


const ExpenseDistributionStatus = {
  UNKNOWN: 0,
  VALID: 1,
  INVALID: 2,
  WARNING: 3,
};

const ExpenseDistributionError = {
  'input.not_exist': 'Đối tượng chi phí không tồn tại',
  'input.invalid_item_category': 'Chủng loại mặt hàng mua vào không hợp lệ',
  'input.invalid_used_department': 'Phòng ban được phân bổ không hợp lệ',
  'input.invalid_employee_department': 'Phòng ban nhân viên không hợp lệ',
  'input.no_related_data': 'Không có dữ liệu cho liên quan đến đối tượng chi phí được cấu hình',
  'output.not_exist': 'Đối tượng tập hợp không tồn tại',
  'output.invalid_item_category': 'Chủng loại mặt hàng bán ra không hợp lệ',
  'output.no_related_data': 'Không có dữ liệu cho liên quan đến đối tượng tập hợp được cấu hình',
};

const DistributionMethod = {
  REVENUE: 'revenue',
  PROFIT: 'profit',
};

const DistributionMethodStr = {
  [DistributionMethod.REVENUE]: 'Theo doanh thu',
  [DistributionMethod.PROFIT]: 'Theo lợi nhuận',
};

const PeriodType = {
  QUARTER: 'quarter',
  MONTH: 'month',
};

const PeriodTypeStr = {
  [PeriodType.QUARTER]: 'Hàng Quý',
  [PeriodType.MONTH]: 'Hàng tháng',
};

const BankPaymentProgress = {
  NONE: 0,
  NOT_COMPLETED: 1,
  COMPLETED: 2,
};

const CurrencyCode = {
  VND: 'VND',
  USD: 'USD',
  EUR: 'EUR',
  JPY: 'JPY',
};

const CurrencyText = {
  [CurrencyCode.VND]: 'đ',
  [CurrencyCode.USD]: '$',
  [CurrencyCode.EUR]: '€',
  [CurrencyCode.JPY]: '¥',
};

const CurrencyColor = {
  [CurrencyCode.VND]: '',
  [CurrencyCode.USD]: 'red',
  [CurrencyCode.EUR]: 'green',
  [CurrencyCode.JPY]: 'yellow',
};

const CurrencyRateType = {
  DEFAULT: 0,
  IN_DAY: 1,
};

const UserRole = {
  MANAGEMENT: 'management',
  ACCOUNTING: 'accounting',
  READONLY: 'readonly',

  ADMINISTRATOR: 'administrator',
  ACCOUNTANT: 'accountant',
  AGENCY: 'agency',
  CUSTOMER: 'customer',
  MANAGER: 'manager',
};

const ItemCategoryAbbr = {
  [ItemCategory.MERCHANDISE]: 'HH',
  [ItemCategory.MATERIAL]: 'NVL',
  [ItemCategory.TOOL]: 'CCDC',

  [ItemCategory.IMMEDIATE_EXPENSE]: 'CPDN',
  [ItemCategory.APPORTION_EXPENSE]: 'CPTT',
  [ItemCategory.PURCHASE_EXPENSE]: 'CPMH',

  [ItemCategory.FINISHED_GOOD]: 'TP',
  [ItemCategory.PRODUCTION_ORDER]: 'ĐH',
  [ItemCategory.SUPPLIED_SERVICE]: 'DV',


  [ItemCategory.FIXED_ASSET_EXPENSE]: 'TSCĐ',
  [ItemCategory.OUTSOURCE_SERVICE]: 'CPTN',

  [ItemCategory.TRADED_SERVICE]: 'DVTM',

  [ItemCategory.OTHER_EXPENSE]: 'CPK',
  [ItemCategory.OTHER_REVENUE]: 'BRK',
};

const ExpenseStatus = {
  USING: 0,
  SOLD: 1,
  PARTIAL: 2,
};

const ExpenseStatusStr = {
  [ExpenseStatus.USING]: 'Đang sử dụng',
  [ExpenseStatus.SOLD]: 'Đã thanh lý',
  [ExpenseStatus.PARTIAL]: 'Thanh lý một phần',
};

const AccountingReportStatus = {
  AUTO: 0,
  DRAFT: 1,
  FINAL: 2,
};

const TrackingDetailAccounts = {
  131: 'customer',
  1388: 'customer',
  3386: 'customer',

  331: 'supplier',
  3388: 'supplier',
  1386: 'supplier',

  3411: 'contact',
  1288: 'contact',
};

const FinancialSpecification = {
  133: 'Thông tư 133',
  200: 'Thông tư 200',
};

const TransactionWarningText = {
  invalid_matching: 'Không có trong sao kê',
  unknown_type: 'Chưa rõ nghiệp vụ',
  missing_reference: 'Chưa rõ KH / NCC',
};

const ContractType = {
  LONG_TERM: 'long_term',
  SHORT_TERM: 'short_term',
  SHORT_TERM_DEDUCT: 'short_term_deduct',
};

const ContractTypeText = {
  [ContractType.LONG_TERM]: 'Dài hạn',
  [ContractType.SHORT_TERM]: 'Thời vụ',
  [ContractType.SHORT_TERM_DEDUCT]: 'Thời vụ KTT',
};

const NoticeContent = {
  E0101: 'Tổng hợp: Thiếu bút toán góp vốn hoặc kết chuyển lãi / lỗ',
  E0102: 'Tổng hợp: Thiếu bút toán Xác định thuế môn bài phải nộp',
  E0103: 'Tổng hợp: Thiếu bút toán Nộp thuế môn bài',
  W0104: 'Hạch toán Có tài khoản 6422 - Chi phí quản lý doanh nghiệp',

  W0201: 'Ngân hàng: Còn nghiệp vụ chưa xác định',
  W0202: 'Ngân hàng: Còn đối tượng chưa xác định',
  E0203: 'Số dư ngân hàng không khớp. Cần kết chuyển lại kế toán từ năm trước sang.',
  E0204: 'Tài khoản Tiền ngân hàng lệch số tổng hợp và chi tiết. Cần tính CĐTK và kết chuyển lại dữ liệu từ năm trước sang.',

  E0301: 'Lệch tổng nợ, có trên bảng cân đối tài khoản',
  W0302: 'Tài khoản 154 dư cuối kỳ',
  W0303: 'Tài khoản 33312 Thuế GTGT hàng nhập khẩu dư cuối kỳ',
  W0304: 'Tài khoản 3333 Thuế xuất, nhập khẩu dư cuối kỳ',
  W0305: 'Tài khoản 33382 Thuế môn bài dư cuối kỳ',
  W0306: 'Thu tiền khách hàng không bán hàng',
  W0307: 'Trả tiền nhà cung cấp không mua hàng',
  E0308: 'Lệch số dư tổng và chi tiết',
  E0309: 'Số dư cuối kỳ âm',
  W0310: 'Chưa có số dư đầu kỳ các tài khoản',
  W0311: 'Chưa có số liệu Kết quả hoạt động kinh doanh năm trước, báo cáo tài chính',
  W0312: 'Chưa có phụ lục kết chuyển lỗ 5 năm, quyết toán thuế TNDN',

  E0401: 'Còn chi phí mua hàng chưa phân bổ',
  W0402: 'Còn mặt hàng chưa cấu hình định mức',
  W0403: 'Có bán ra không được phân bổ chi phí lương',

  W0501: 'Có hàng hóa âm kho',
  W0502: 'Có hàng hóa mua nhưng không dùng',
  W0503: 'Có nguyên vật liệu âm kho',
  W0504: 'Có nguyên vật liệu mua nhưng không dùng',
  W0505: 'Có nguyên CCDC âm kho',
  W0506: 'Có nguyên CCDC mua nhưng không dùng',

  W0601: 'Chưa lập tờ khai thuế GTGT',
  W0602: 'Chưa lập báo cáo sử dụng hóa đơn',

  E0701: 'Giám đốc có trong bảng lương công ty TNHH 1 thành viên',

  W0901: 'Hoá đơn mua hàng trùng',
  W0902: 'Hoá đơn bán hàng trùng',

};

const SalaryMethod = {
  NONE: 'none',
  TIME: 'time',
  PRODUCT: 'product',
  COMMISSION: 'commission',
  AUTO: 'auto',
};

const SalaryMethodText = {
  [SalaryMethod.NONE]: 'Không',
  [SalaryMethod.TIME]: 'Lương thời gian',
  [SalaryMethod.PRODUCT]: 'Lương sản phẩm',
  [SalaryMethod.COMMISSION]: 'Lương kinh doanh',
};


const AccountingReportVersion = {
  AUTO: 'auto',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  CUSTOM: 'custom',
};


const AccountingReportVersionText = {
  [AccountingReportVersion.AUTO]: 'Tự động',
  [AccountingReportVersion.PRIMARY]: 'Chính thức',
  [AccountingReportVersion.SECONDARY]: 'Điều chỉnh',
  [AccountingReportVersion.CUSTOM]: 'Tùy chọn',
};

const TradeEntryCategory = {
  VAT: 1,
  CUSTOMS: 3,
  CORRECTION: 4,
  NO_VAT_EXCLUDED: 2,
  NO_VAT_INCLUDED: 5,
};


const TradeEntryCategoryText = {
  [TradeEntryCategory.VAT]: 'HĐ GTGT',
  [TradeEntryCategory.CUSTOMS]: 'Tờ khai x.n.khẩu',
  [TradeEntryCategory.CORRECTION]: 'HĐ điều chỉnh',
  [TradeEntryCategory.NO_VAT_EXCLUDED]: 'Không hợp lệ',
  [TradeEntryCategory.NO_VAT_INCLUDED]: 'Không hóa đơn',
};

const ObjectState = {
  DRAFT: 'DRAFT',
  REVIEW_AGAIN: 'REVIEW_AGAIN',
  REVIEW: 'REVIEW',
  APPROVED: 'APPROVED',
  ERROR: 'ERROR',
};

const ObjectStateText = {
  DRAFT: 'Lưu nháp',
  REVIEW_AGAIN: 'Cần duyệt lại',
  REVIEW: 'Chờ duyệt',
  APPROVED: 'Duyệt',
  ERROR: 'Không duyệt',
};

const InventoryEntryCategory = {
  EXPORT_TO_SALE: 1,
  EXPORT_TO_MANAGEMENT: 2,
  EXPORT_TO_PRODUCTION: 3,
  EXPORT_TO_FIXED_ASSET: 4,
  EXPORT_TO_CONSTRUCTION: 5,
  EXPORT_OTHER: 6,
};

const InventoryEntryCategoryText = {
  [InventoryEntryCategory.EXPORT_TO_SALE]: 'Bán hàng',
  [InventoryEntryCategory.EXPORT_TO_MANAGEMENT]: 'Quản lý',
  [InventoryEntryCategory.EXPORT_TO_PRODUCTION]: 'Sản xuất',
  [InventoryEntryCategory.EXPORT_TO_FIXED_ASSET]: 'Mua sắm TSCĐ',
  [InventoryEntryCategory.EXPORT_TO_CONSTRUCTION]: 'Xây dựng cơ bản',
  [InventoryEntryCategory.EXPORT_OTHER]: 'Khác',
};

const InventoryAccountText = {
  156: 'Hàng hoá',
  152: 'Nguyện vật liệu',
  153: 'Công cụ dụng cụ',
};

const ObjectStatus = {
  ACTIVE: 0,
  INACTIVE: -1,
  INVISIBLE: -2,
};

module.exports = {
  ItemCategory,
  ItemCategoryStr,
  ItemCategoryGroup,
  EntryCategory,
  ReceiptCategory,
  PaymentCategory,
  PaymentStatus,
  PaymentMethod,
  AmountPercentPinned,
  PricePinned,
  Department,
  DepartmentStr,
  VatMethod,
  VatMethodStr,
  VatCategory,
  VatCategoryStr,
  ConsumeCategory,
  ConsumeCategoryStr,
  PaymentStatusStr,
  ExpenseRecordCategory,
  AccountRecordCategory,
  AccountRecordSubCategory,
  FileStatus,
  FileType,
  FileTypeInfo,
  FileCategory,
  FileCategoryInfo,
  InputRequiredFileCategory,
  FileState,
  FileStateInfo,
  WeightType,
  MaterialExportMethod,
  MaterialExportMethodStr,
  InventoryRecordType,
  CommentState,
  NotificationStatus,
  FGPMethod,
  FGPMethodStr,
  ExpenseInputType,
  ExpenseInputTypeStr,
  ExpenseOutputType,
  ExpenseOutputTypeStr,
  ExpenseDistributionStatus,
  ExpenseDistributionError,
  ExpenseOutputTypeGroups,
  ExpenseInputTypeGroups,
  DistributionMethod,
  DistributionMethodStr,
  PeriodType,
  PeriodTypeStr,
  BankPaymentProgress,
  CurrencyCode,
  CurrencyRateType,
  CurrencyText,
  UserRole,
  ItemCategoryAbbr,
  ExpenseStatus,
  ExpenseStatusStr,
  AccountingReportStatus,
  TrackingDetailAccounts,
  FinancialSpecification,
  TransactionWarningText,
  ContractType,
  ContractTypeText,
  NoticeContent,
  SalaryMethod,
  SalaryMethodText,
  AccountingReportVersion,
  AccountingReportVersionText,
  TradeEntryCategory,
  TradeEntryCategoryText,
  CurrencyColor,
  ObjectState,
  ObjectStateText,
  InventoryEntryCategory,
  InventoryAccountText,
  InventoryEntryCategoryText,
  ObjectStatus,
};



// WEBPACK FOOTER //
// ./src/utils/enums.js